import React from 'react';

const LIFE_AREAS = [
  { value: '', label: 'Optional — preferred life area' },
  { value: 'relationships', label: 'Relationships' },
  { value: 'work', label: 'Work and vocation' },
  { value: 'money', label: 'Money and stability' },
  { value: 'inner', label: 'Inner life' },
  { value: 'expression', label: 'Self-expression' },
  { value: 'timing', label: 'Current year / timing' },
];

export default function NumerologyReportForm({
  values,
  onChange,
  onSubmit,
  submitting,
}) {
  const field = (name) => ({
    value: values[name] ?? '',
    onChange: (e) => onChange(name, e.target.value),
  });

  return (
    <form className="amm-num-form" lang="en" onSubmit={onSubmit} noValidate>
      <div className="amm-num-field-grid">
        <label className="amm-num-field">
          <span className="amm-num-label">First name *</span>
          <input type="text" name="firstName" autoComplete="given-name" {...field('firstName')} />
        </label>
        <label className="amm-num-field amm-num-field-span2">
          <span className="amm-num-label">Full birth name (as on your birth record) *</span>
          <input
            type="text"
            name="fullBirthName"
            autoComplete="name"
            placeholder="e.g. Anna Marie Smith"
            {...field('fullBirthName')}
          />
        </label>
        <div className="amm-num-field amm-num-field-span2">
          <label className="amm-num-dob-label" htmlFor="numerology-date-of-birth">
            <span className="amm-num-label">Date of birth *</span>
          </label>
          <input
            id="numerology-date-of-birth"
            type="date"
            name="dateOfBirth"
            lang="en"
            {...field('dateOfBirth')}
          />
          <p className="amm-num-field-hint">
            Use your birth record. Your browser may display the date in your local format.
          </p>
          <p className="amm-num-field-hint">
            Internally, the report uses a normalized YYYY-MM-DD date.
          </p>
        </div>
        <label className="amm-num-field">
          <span className="amm-num-label">Optional — current name / married name</span>
          <input type="text" name="currentName" {...field('currentName')} />
        </label>
        <label className="amm-num-field">
          <span className="amm-num-label">Timing year (Personal Year)</span>
          <input type="number" name="targetYear" min="1900" max="2100" {...field('targetYear')} />
        </label>
        <label className="amm-num-field amm-num-field-span2">
          <span className="amm-num-label">Optional — life area emphasis</span>
          <select name="preferredLifeArea" {...field('preferredLifeArea')}>
            {LIFE_AREAS.map((o) => (
              <option key={o.value || 'empty'} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="amm-num-actions">
        <button type="submit" className="amm-num-submit" disabled={submitting}>
          {submitting ? 'Preparing…' : 'Create your report'}
        </button>
      </div>
    </form>
  );
}
